import { Component, Input, OnInit } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";

/**
 * Component responsible for displaying important information about the frontend.
 */
@Component({
  selector: 'colimo-frontend-info',
  templateUrl: './frontend-info.component.html',
  styleUrls: ['./frontend-info.component.scss'],
  imports: [
    TranslateModule
  ]
})
export class FrontendInfoComponent implements OnInit {
  @Input() public name: string;
  @Input() public version: string;

  constructor() {}

  public ngOnInit(): void {}
}
